import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["tinkoffauth"];
export default (function (stage, callback) {
  if (window.S7tinkoff) {
    var _window$S7tinkoff = window.S7tinkoff,
        apiId = _window$S7tinkoff.apiId,
        domain = _window$S7tinkoff.domain,
        pathAuth = _window$S7tinkoff.path.auth,
        setMessage = _window$S7tinkoff.setMessage;
    var redirect = 'https://myprofile.s7.ru/auth/tinkoff';
    var scope = '%20%7B%20%22inn%22%20%3A%20%227701607660%22%2C%20%22kpp%22%20%3A%20%22770701001%22%20%7D';
    var authUrl = "".concat(domain, "/").concat(pathAuth, "?client_id=").concat(apiId, "&redirect_uri=").concat(redirect, "&state=").concat(redirect, "&response_type=code&scope_parameters=").concat(scope);
    window.open(authUrl, 'Tinkoff Auth', 'width=768,height=560');

    if (!setMessage) {
      window.addEventListener('message', function handleMessage(event) {
        if (redirect.indexOf(event.origin) >= 0) {
          try {
            var data = event.data ? JSON.parse(event.data) : {};

            var tinkoffauth = data.tinkoffauth,
                response = _objectWithoutProperties(data, _excluded);

            if (tinkoffauth && !response.error) {
              if (!response.error) {
                callback(response);
              }

              event.source.close();
            }
          } catch (e) {// не обрабатываем
          }
        }
      });
      window.S7tinkoff.setMessage = true;
    }
  }
});